<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">

            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Medical Assessment</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
										v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <ul class="nav gap-1 mb-4">
              <li class="nav-item">
                <button
                  class="btn btn btn-success"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  @click="add()"
                >Tambah Pertanyaan</button>
              </li>
            </ul>

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="w-50 text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Pertanyaan
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Skor
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tipe Input
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tipe
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataList" :key="req.id">
                    <th scope="row">{{ idx + 1 }}</th>
                    <td class="text-nowrap">{{ req.question_text }}</td>
                    <td class="text-center">{{ req.score || '-' }}</td>
                    <td class="text-center text-nowrap text-capitalize">
                      {{ req.input_type
                      || '-' }}
                    </td>
                    <td class="text-center">{{ req.type }}</td>
                    <td class="text-center">
                      <small
                        :class="req.statusId == 7 ? 'text-bg-success' : 'text-bg-dark'"
                        class="badge fs-1 bg-opacity-75"
                      >{{ req.site_status.status_name }}</small>
                    </td>
                    <td class="text-nowrap text-end">
                      <a
                        class="btn btn-sm btn-outline-primary me-1"
                        @click="edit(req.id)"
                        title="Edit"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        role="button"
                      >
                        <i class="ti ti-edit fs-3"></i>
                      </a>

                      <a
                        href="#"
                        class="btn btn-sm btn-outline-danger liveToastBtn"
                        title="Hapus"
                        @click="deleteData(req.id)"
                      >
                        <i class="ti ti-trash fs-3"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <form @submit.prevent="onSubmit">
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="modalNewExaminationlLabel">{{formTitle}} Pertanyaan</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-4">
                <label for class="form-label">Jenis Formulir *</label>
                <div>
                  <div class="form-check mb-2">
                    <input
                      v-model="form.type"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="assessment"
                      autocomplete="off"
                      required
                    >
                    <label class="form-check-label" for="inlineRadio1">Assessment</label>
                  </div>
                  <div class="form-check mb-2">
                    <input
                      v-model="form.type"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="activity"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio2">Activity</label>
                  </div>
                  <div class="form-check mb-2">
                    <input
                      v-model="form.type"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio6"
                      value="evaluation"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio6">Evaluation</label>
                  </div>
                  <div class="form-check">
                    <input
                      v-model="form.type"
                      class="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio7"
                      value="emergency"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio7">Emergency</label>
                  </div>
                </div>
              </div>

              <div class="mb-4">
                <label for class="form-label">Sesi Pertanyaan *</label>
                <select v-model="form.sectionId" class="form-select" autocomplete="off" required>
                  <option value disabled hidden>--- Pilih ---</option>
                  <option
                    v-for="item in sectionList"
                    :value="item.id"
                    :key="`sp${item.id}`"
                  >{{ item.type_name }}</option>
                </select>
              </div>

              <div class="mb-4">
                <label for class="form-label">Indikator Risiko *</label>
                <select v-model="form.indicatorId" class="form-select" autocomplete="off" required>
                  <option value disabled hidden>--- Pilih ---</option>
                  <option
                    v-for="item in riskIndicatorList"
                    :value="item.id"
                    :key="`ri${item.id}`"
                  >{{ item.risk_name }}</option>
                </select>
              </div>

              <div class="mb-4">
                <label for class="form-label">Isi Pertanyaan *</label>
                <textarea
                  v-model="form.question_text"
                  class="form-control"
                  placeholder="Isi Pertanyaan..."
                  rows="3"
                  autocomplete="off"
                  required
                ></textarea>
              </div>

              <div class="mb-4">
                <label for class="form-label">Skor</label>
                <input
                  v-model="form.score"
                  type="number"
                  class="form-control"
                  placeholder="Skor..."
                  min="0"
                  max="100"
                  autocomplete="off"
                >
              </div>

              <div class="mb-4">
                <label for class="form-label">Tipe Input *</label>
                <select v-model="form.input_type" class="form-select" autocomplete="off" required>
                  <option value>--- Pilih ---</option>
                  <option value="radio">Radio</option>
                  <option value="checkbox">Checkbox</option>
                  <option value="text">Text</option>
                  <option value="textarea">Textarea</option>
                </select>
              </div>

              <div v-if="form.input_type == 'radio' || form.input_type == 'checkbox'" class="mb-4">
                <label for class="form-label">Opsi Jawaban *</label>
                <textarea
                  v-model="form.option"
                  class="form-control"
                  placeholder="Ya,Tidak"
                  rows="3"
                  autocomplete="off"
                  required
                ></textarea>
                <small
                  class="text-dark fst-italic"
                >** Untuk opsi jawaban lebih dari 1, pisah dengan simbol koma ( , )</small>
              </div>

              <div class="mb-4">
                <div class="form-check">
                  <input
                    v-model="form.is_required"
                    class="form-check-input"
                    type="checkbox"
                    value
                    id="checkDefault"
                    autocomplete="off"
                  >
                  <label
                    class="form-check-label"
                    for="checkDefault"
                  >Set mandatory untuk pertanyaan ini?</label>
                </div>
              </div>

              <div>
                <label for class="form-label">Status</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.statusId"
                      class="form-check-input"
                      type="radio"
                      name="statusId"
                      id="inlineRadio11"
                      value="7"
                      autocomplete="off"
                      checked
                    >
                    <label class="form-check-label" for="inlineRadio11">Publish</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      v-model="form.statusId"
                      class="form-check-input"
                      type="radio"
                      name="statusId"
                      id="inlineRadio21"
                      value="8"
                      autocomplete="off"
                    >
                    <label class="form-check-label" for="inlineRadio21">Draft</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Batal</button>
              <button type="submit" class="btn btn-success">Simpan</button>
              <!-- liveToastBtn -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			form: {
				id: '',
				type: 'assessment',
				question_text: '',
				input_type: '',
				score: '',
				option: '',
				sectionId: '',
				indicatorId: '',
				is_required: '',
				statusId: '7'
			},
			cariTitle: '',
			formTitle: 'Tambah',
			url: 'medical_examination/add',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		this.$store.dispatch('location/getDataSecond', {
			url: `medical_assessment/data/risk_indicators/`
		})
		this.$store.dispatch('location/getDataThird', {
			url: `medical_assessment/data/section/`
		})
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation',
			riskIndicatorList: 'location/getDataSecond',
			sectionList: 'location/getDataThird'
		})
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `medical_assessment`,
					params: {
						question_text: this.cariTitle,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('==> success get data')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		onSubmit() {
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						document.querySelector('#exampleModal [data-bs-dismiss="modal"]').click()
						this.form = {
							id: '',
							type: 'assessment',
							question_text: '',
							input_type: '',
							score: '',
							option: '',
							sectionId: '',
							indicatorId: '',
							is_required: '',
							statusId: '7'
						}
					} else {
					}
				})
		},
		deleteData(id) {
			var conf = confirm('Kamu akan menghapus rekaman ini. Apa kamu yakin?')
			if (conf === false) {
				return
			}

			this.$store
				.dispatch('location/createNewRecord', {
					url: 'medical_assessment/delete/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			console.log(data)
			this.form = {
				id: id,
				type: data.type,
				question_text: data.question_text,
				input_type: data.input_type,
				score: data.score,
				option: data.option,
				sectionId: data.sectionId,
				indicatorId: data.indicatorId,
				is_required: data.is_required,
				statusId: data.statusId
			}
			this.formTitle = 'Edit'
			this.url = 'medical_assessment/update/' + id
			this.method = 'put'
		},
		add() {
			this.form = {
				id: '',
				type: 'assessment',
				question_text: '',
				input_type: '',
				score: '',
				option: '',
				sectionId: '',
				indicatorId: '',
				is_required: '',
				statusId: '7'
			}
			this.formTitle = 'Tambah'
			this.url = 'medical_assessment/add'
			this.method = 'post'
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
